import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ArticlesGrid from '../components/ArticlesGrid';
import Pagination from '../components/Pagination';
import { useSiteData } from '../data/SiteDataContext';
import { POSTS_PER_PAGE } from './HomePage';

function CategoryPage() {
    const { slug, pageNum } = useParams();
    const { status, getCategoryById, getPostsForCategory } = useSiteData();

    const category = getCategoryById(slug);
    const categoryPosts = getPostsForCategory(category);
    const totalPages = Math.max(1, Math.ceil(categoryPosts.length / POSTS_PER_PAGE));
    const requestedPage = pageNum ? parseInt(pageNum, 10) : 1;
    const currentPage = Number.isFinite(requestedPage) ? requestedPage : 1;

    if (status === 'loading') {
        return <p className="small-meta site-loading">Loading …</p>;
    }

    if (status === 'error') {
        return <p className="small-meta site-loading">Failed to load documents. Refresh to retry.</p>;
    }

    if (!category) {
        return <Navigate to="/" replace />;
    }

    if (pageNum && (!Number.isFinite(requestedPage) || requestedPage < 2)) {
        return <Navigate to={`/category/${slug}`} replace />;
    }

    if (currentPage > totalPages) {
        return <Navigate to={`/category/${slug}`} replace />;
    }

    const start = (currentPage - 1) * POSTS_PER_PAGE;
    const pagePosts = categoryPosts.slice(start, start + POSTS_PER_PAGE);

    return (
        <>
            <header className="archive-header">
                <div className="eyebrow" style={{ marginBottom: '.4rem' }}>Category</div>
                <h1>{category.label}</h1>
            </header>
            <ArticlesGrid posts={pagePosts} />
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getPageLink={(page) => (
                    page <= 1 ? `/category/${slug}` : `/category/${slug}/page/${page}`
                )}
            />
        </>
    );
}

export default CategoryPage;
